import { apiClient } from "./core/client";
import type { VehicleDto, CustomerDto, PaginatedResponse } from "@/types/dto";

export interface CreateVehiclePayload {
  customerId?: string | null;
  make: string;
  model: string;
  year: number;
  licensePlate: string;
  vin?: string | null;
  color?: string | null;
  mileage?: number | null;
  engineNumber?: string | null;
  registrationDate?: string | null;
  notes?: string | null;
}

export type UpdateVehiclePayload = Partial<CreateVehiclePayload>;

export interface VehicleWithCustomer extends VehicleDto {
  customer: CustomerDto;
}

export async function getVehicles(params?: {
  page?: number;
  limit?: number;
  search?: string;
  customerId?: string;
}) {
  const { data } = await apiClient.get<PaginatedResponse<VehicleWithCustomer>>(
    "/api/vehicles",
    { params }
  );
  return data;
}

export async function getVehicle(id: string) {
  const { data } = await apiClient.get<VehicleWithCustomer>(
    `/api/vehicles/${id}`
  );
  return data;
}

export async function createVehicle(payload: CreateVehiclePayload) {
  const { data } = await apiClient.post<VehicleDto>("/api/vehicles", payload);
  return data;
}

export async function updateVehicle(id: string, payload: UpdateVehiclePayload) {
  const { data } = await apiClient.patch<VehicleDto>(
    `/api/vehicles/${id}`,
    payload
  );
  return data;
}

export async function deleteVehicle(id: string) {
  await apiClient.delete(`/api/vehicles/${id}`);
}
